/*----------------------------------------------------------------------------------------

Hello, welcome to introduction to how the F do I use JsCarousel?

Eg.

let wrapper = $('#whatever');
let options = {
    endpoint: 'carousels/homepage/featuredshows/offset/{offset}/limit/{limit}/'
}
wrapper.JsCarousel(options);

** by default `offset` and `limit` will be set with default values

----------------------------------------------------------------------------------------
            __  _
 ___  ___  / /_(_)__  ___  ___
/ _ \/ _ \/ __/ / _ \/ _ \(_-<
\___/ .__/\__/_/\___/_//_/___/
   /_/
----------------------------------------------------------------------------------------

let options = {
    endPoint: '/WHERE/MY/API/ENDPOINT/AT/BOI/{placeholder1}/AND/{placeholder2}/',

    // PARAMS THAT WILL REPLACE IN ENDPOINT (optional) (offset and limit have default values, you don't need to provide)
    params: {
        placeholder1: 52,
        placeholder2: 4
    },

    // PASS ANY TYPE OF DROPDOWN FILTER INSTANCE HERE (optional)
    filters: new DropdownFilter([
            {
                title: 'Option A',
                value: 1
            }
            {
                title: 'Option B',
                value: 2
            }
        ]),


    // SLICK.JS SETTINGS FOR `responsive` (optional)
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4
            }
        }
    ]

};

----------------------------------------------------------------------------------------
                    __
 ___ _  _____ ___  / /____
/ -_) |/ / -_) _ \/ __(_-<
\__/|___/\__/_//_/\__/___/

----------------------------------------------------------------------------------------

wrapper.on('videoDataLoad', (e, result) => {
    console.log('data pulled');
});

- `videoDataLoad`
Arguments: result
Fires after data is pulled successfully

- `videoDataLoadError`
Fires after data failed to load from endpoint

- `templateDidRender`
Fires after the DOM is rendered

- ALL EVENTS THAT SLICK.JS FIRES
Check out: http://kenwheeler.github.io/slick/

----------------------------------------------------------------------------------------*/

import layout from 'templates/carousels/layout.tpl';
import template from 'templates/carousels/__carousel.tpl';
import 'carousels/helpers/ellipsify';
import { Navigation, Swiper, Virtual } from 'vendor/swiper.esm';
import { getLocale } from 'services/LocalizationService';
import { trackAction } from 'helpers/trackingOM';
import Breakpoints from 'helpers/breakpoints';
import FathomTracking, { Tracking } from 'shared/fathomTracking';
import ImpressionTracking, { CarouselTracking } from 'shared/impressionTracking';
import { UpdateFocusableCarousel } from 'components/accessibilityCarousel';
import { JsCarouselTracking } from '../../carousels/helpers/JsCarouselTracking';
import Domain from 'helpers/Domain'; // ~/src/web-package-coreui/src/js/helpers/Domain.js

Swiper.use([Virtual, Navigation]);
const MOVIES_TEXT = 'movies';

export class JsCarousel {
    constructor(element, options) {
        let defaultOptions = {
            infinite: false,
            layout: layout,
            template: template,
            useBuffer: true,
            prevArrow:
                '<a class="carousel-prev focusable" tabindex="0" role="button" aria-label="Previous Slides"></a>',
            nextArrow:
                '<a class="carousel-next focusable" tabindex="0" role="button" aria-label="Next Slides"></a>',

            // stores the xhr response, used for arrow tracking
            xhrResult: ''
        };

        this.options = $.extend(defaultOptions, options);

        this._ = element;
        this._wrapper = $(this._);
        this.showId = null;
        this.virtualSlides = null;
        this.lastIndex = 0;
        this.lastBreakPoint = null;
        this.maxSlides = 6;
        this.guideItem;
        this.position = null;
        this.lastSlidesPerGroup = null;
        this.bodyTag = $('body');
        this.hpDescriptionsTestOn = this.bodyTag.hasClass(
            'test-homepage_descriptions_web-description'
        );
        this.hasFathomTracking = CBS.Registry.fathomHost && CBS.Registry.user.id && CBS.Registry.pageType === 'HOMEPAGE';
        // Discards back/forward cache on Safari
        if (this.hpDescriptionsTestOn) {
            window.addEventListener('pageshow', (event) => {
                if (event.persisted) {
                    document.location.reload();
                }
            });
        }
        this.__init();
        this.__trackCarousels();
        // ABTEST: homepage_descriptions_web
        this.__initAnimation();
    }

    /**
     * This will be run if no endpoint is set (meaning static carousel)
     * @private
     */
    __setupSettingsForPhpCarousel() {
        this._swiperContainer = this._wrapper.find('.wrap');
        this.options.useBuffer = false;
    }

    __init() {
        this.__eventListeners();

        //If data available
        if (this.options.data) {
            this.__renderCarousel(this.options.data);
            this.__initFathomTracking();
            this.__initImpressionTracking();
            return;
        }

        let overridesParams = {};
        if (this.options.filter) {
            overridesParams.season = this.options.filter.options[0].season;
        }
        if (this.options.editPoint) {
            overridesParams.random = Math.floor(Math.random() * 100 + 1); // to force uncached version upon edit;
        }
        let endpoint = this.__buildEndpoint(overridesParams);
        this.lastBreakPoint = this.__checkBreakpoint();
        this.__pullAndRender(endpoint, (result) => {
            // save state of response (for arrow tracking)
            this.options.xhrResult = result;
            this.__initSwiper();
            this.total = (result && result.total) || 0;
            this.__trackingArrow();
            this.__initFathomTracking();
            this.__initImpressionTracking();
            this.__initEdit();
            // ABTEST: homepage_descriptions_web
            this.__initAnimation();
        });
    }

    __initFathomTracking() {
        if (this.hasFathomTracking) {
            JsCarousel.lastCarouselFlag = this._wrapper.data('displayid');
            this.fathomTracking = new FathomTracking(this._wrapper, this.swiper);
        }
    }
    
    __initImpressionTracking() {
        // only do impression tracking on homepage (for now)
        if(window.location.href.indexOf('/home') !== -1) {
            this.impressionTracking = new ImpressionTracking(this._wrapper, this.swiper);
        }
    }

    __deleteSelectedData(data, editPoint, reloadPoint, trackingParam) {
        const self = this;
        var s_params = {
            selections: data,
            editPoint: editPoint
        };
        $.ajax({
            url: CBS.Registry.region.prefix + '/carousels/homepage/edit/',
            type: 'POST',
            dataType: 'json',
            data: s_params,
            error: function () {
                console.log('Error 1 - Ajax call failed.');
            },
            success: function (resp) {
                if (!resp.success) {
                    console.log('Error 2 - ' + resp.message);
                } else {
                    self.__trackingDeletedItems(resp.result, trackingParam);
                    self.__editAndReload(reloadPoint);
                }
            }
        });
    }

    __trackingDeletedItems(items, trackingParam) {
        $.each(items, function (index, value) {
            var trackingParams = value.split('|');
            var showSeriesId = trackingParams[0];
            var showSeriesTitle = trackingParams[1];
            var showGenre = trackingParams[2];
            var showDayPart = trackingParams[3];
            var showEpisodeId = trackingParams[4];
            var showEpisodeLabel = trackingParams[5];
            var showSeasonNumber = trackingParams[6];
            var showEpisodeNumber = trackingParams[7];
            var showAirDate = trackingParams[8];

            if (trackingParam == 'trackEditKW') {
                let objTracking;

                if(trackingParams[0] != "-1"){
                    objTracking = {
                        showSeriesId: showSeriesId,
                        showSeriesTitle: showSeriesTitle,
                        removeKWComplete: '1'
                    }
                }else{
                    objTracking = {
                        movieId:trackingParams[9],
                        movieTitle:trackingParams[5],
                        removeKWComplete: '1'
                    }
                }

                trackAction('trackRemoveKW', objTracking);
            }
        });
    }

    __setArrowPosition() {
        if (this.guideItem) {
            let $prevArrow = this.swiper.navigation.$prevEl;
            let $nextArrow = this.swiper.navigation.$nextEl;

            let isKidCarousel = this._wrapper.parents('.kids-carousel').length ? true : false;

            let height = $(this.swiper.slides[1]).find('.thumb-wrapper')[0].offsetHeight - 10; //margin-bottom
            let heightArrow = 10;
            let arrowPositionY = (height - heightArrow) * 0.5;

            if (isKidCarousel) {
                arrowPositionY = (height - heightArrow) * 0.75;
            }
            $nextArrow.css('background-position', `center ${arrowPositionY}px`);
            $prevArrow.css('background-position', `center ${arrowPositionY}px`);
        }
    }

    __trackingArrow() {
        if (this.swiper.navigation) {
            let $prevArrow = this.swiper.navigation.$prevEl;
            let $nextArrow = this.swiper.navigation.$nextEl;

            // set aa-link on jsCarousel arrows based on xhr response
            if (this.options.xhrResult) {
                $nextArrow.attr('aa-link', this.options.xhrResult.rightArrow);
                $prevArrow.attr('aa-link', this.options.xhrResult.leftArrow);
            }

            //adjust position

            if (this.swiper.slides[1]) {
                this.guideItem = $(this.swiper.slides[1]).find('.thumb-wrapper')[0];
                this.__setArrowPosition();
            }

            // setup arrow click handlers
            $nextArrow.on('click', function () {
                // execute tracking in timeout so it doesn't interrupt UI thread
                setTimeout(() => {
                    try {
                        om.trackClick({
                            item: $(this).attr('aa-link')
                        });
                    } catch (e) {}
                }, 100);
            });

            $prevArrow.on('click', function () {
                // execute tracking in timeout so it doesn't interrupt UI thread
                setTimeout(() => {
                    try {
                        om.trackClick({
                            item: $(this).attr('aa-link')
                        });
                    } catch (e) {}
                }, 100);
            });
        }
    }

    __initEdit() {
        if (this.options.editPoint) {
            const self = this;

            this._wrapper.find('.edit-cancel-carousel').on('click', function () {
                console.log('Edit cancelled');
                if (self.options.trackingParam === 'trackEditKW') {
                    trackAction('trackCancelKW', {
                        cancelKW: '1'
                    });
                }

                $('input[name=editor]:checked', self._wrapper).each(function (index) {
                    $(this).prop('checked', false);
                });
                $(this).parent().find('a').attr('tabindex', '0'); // in case you clicked cancel while keyboard tab/focus
                $(this).parent().children('.video-carousel-box').addClass('editOff');
                $(this).parent().children('.video-carousel-box').removeClass('editOn');
                $(this).parent().children('.edit-carousel').text(getLocale('edit'));
                $(this).css('display', 'none');
            });

            this._wrapper.find('.edit-carousel').on('click', function () {
                if ($(this).text() == getLocale('remove')) {
                    self._wrapper.find('.edit-cancel-carousel').css('display', 'none');

                    var itemsSelected = [];

                    $('input[name=editor]:checked', self._wrapper).each(function (index) {
                        itemsSelected.push($(this).val());
                    });

                    $(this).parent().children('.video-carousel-box').removeClass('editOn');
                    $(this).parent().children('.video-carousel-box').addClass('editOff');

                    if (itemsSelected.length > 0) {
                        self.__deleteSelectedData(
                            itemsSelected,
                            self.options.editPoint,
                            self.options.reloadPoint,
                            self.options.trackingParam
                        );
                        self._wrapper.find('.carousel-container').css('opacity', '0');
                    } else {
                        console.log('No items selected.');
                    }
                } else {
                    if (self.options.trackingParam === 'trackEditKW') {
                        trackAction('trackEditKW', {
                            editKW: '1'
                        });
                    }

                    $(this).parent().children('.video-carousel-box').addClass('editOn');
                    $(this).parent().children('.video-carousel-box').removeClass('editOff');
                    self._wrapper.find('.edit-cancel-carousel').css('display', 'block');
                }
                $(this).text(
                    $(this).text() == getLocale('remove') ? getLocale('edit') : getLocale('remove')
                );
            });

            $('input[name=editor]').change(function () {
                if ($(this).is(':checked')) {
                    $(this).parent().children('.overlay').css('opacity', '.55');
                    $(this).parent().children('.overlay').css('background-color', '#1D1D1D');
                } else {
                    $(this).parent().children('.overlay').css('opacity', '1');
                    $(this)
                        .parent()
                        .children('.overlay')
                        .css(
                            'background',
                            'linear-gradient(180deg, rgba(0,0,0,0.5508578431372548) 0%, rgba(0,0,0,0) 35%, rgba(0,0,0,0) 100%)'
                        );
                }
            });
        }
    }

    __initSwiper() {
        const self = this;

        let swiperParameters = {
            simulateTouch: false,
            spaceBetween: 10,
            updateOnImagesReady: true,
            navigation: {
                nextEl: '.carousel-next',
                prevEl: '.carousel-prev'
            },
            on: {
                init: function () {
                    self._wrapper.removeClass('hidden');
                }
            },

            breakpoints: self.options.responsive,
            watchSlidesVisibility: true
        };

        if (this.virtualSlides) {
            swiperParameters.virtual = {
                slides: []
            };
        }

        if (this.options.centerInsufficientSlides) {
            swiperParameters.centerInsufficientSlides = true;
        }

        this.swiper = new Swiper(this._swiperContainer, swiperParameters);
        this.__appendVirtualSlides(true);
        if (CBS.Registry.lazyImage) {
            setTimeout(CBS.Registry.lazyImage.revalidate, 5);
        }
        this.__setupSwiperInternalEvents();
    }

    /**
     * proxy listeners for internal element of slick
     * @param slick
     * @private
     */
    __setupSwiperInternalEvents() {
        const self = this;

        if (!self.position) {
            self.position = self._wrapper.parents('.js-le-carousel').data('position');
        }

        if (Domain.isInternational() && self.hasFathomTracking) {
            $(window).on('focus', function () {
                if (self.fathomTracking) {
                    if (JsCarousel.lastCarouselFlag === self._wrapper.data('displayid')) {
                        self.fathomTracking.updateFathomResize();
                        self.impressionTracking.updateImpressionResize();
                    }
                }
            });
        }

        this.swiper.on('slideNextTransitionStart', () => {
            self.__revalidateLazyLoadImages();
        });
        this.swiper.on('slideNextTransitionEnd', function () {
            if (
                this.activeIndex + this.params.slidesPerView >=
                self.lastIndex - this.params.slidesPerView
            ) {
                self.__nextBuffer();
            }
            self.__trackCarousels();

            if (self.fathomTracking) {
                self.fathomTracking.updateFathomTracking(self.position);
            }
            if (self.impressionTracking) {
                self.impressionTracking.updateImpressionTracking(self.position);
            }
        });

        // START ABTEST: homepage_descriptions_web
        if (this.hpDescriptionsTestOn) {
            this.swiper.on('slideChangeTransitionStart', function () {
                $(this.el).css({ 'pointer-events': 'none' });
            });
            this.swiper.on('slideChangeTransitionEnd', function () {
                const thisCarousel = this.el;
                self.__initAnimation(() =>
                    setTimeout(() => $(thisCarousel).css({ 'pointer-events': 'unset' }), 50)
                );
            });
        }
        this.swiper.on('reachEnd', function () {
            self.__initAnimation();
        });

        if (this.hasFathomTracking) {
            this.swiper.on('slidePrevTransitionEnd', function () {
                if (self.fathomTracking) {
                    self.fathomTracking.updateFathomTracking(self.position);
                }
                if (self.impressionTracking) {
                    self.impressionTracking.updateImpressionTracking(self.position);
                }
            });
        }

        let moveTimeout;
        this.swiper.on('sliderMove', () => {
            if (moveTimeout) {
                clearTimeout(moveTimeout);
            }

            moveTimeout = this.__revalidateLazyLoadImages(20);
        });

        let resizeTimeout;
        this.swiper.on('resize', function () {
            let breakpoints = self.__checkBreakpoint();
            this.params.slidesPerView = breakpoints.slidesPerView;
            this.params.slidesPerGroup = breakpoints.slidesPerGroup;

            if (
                this.slides.length < self.maxSlides &&
                this.activeIndex > 0 &&
                self.lastBreakPoint.slidesPerView > breakpoints.slidesPerView
            ) {
                this.slideTo(0);
            }

            self.lastBreakPoint = breakpoints;
            self.virtualSlides ? this.virtual.update() : this.slideTo(this.activeIndex);
            self.__setArrowPosition();
            
            if (resizeTimeout) {
                clearTimeout(resizeTimeout);
            }

            if (self.hasFathomTracking) {
                resizeTimeout = setTimeout(() => {
                    if (self.fathomTracking) {
                        if (self.swiper.params.slidesPerGroup !== self.lastSlidesPerGroup) {
                            self.fathomTracking.updateFathomResizePerCarousel(self.position);
                            self.impressionTracking.updateImpressionResizePerCarousel(self.position);
                            self.lastSlidesPerGroup = self.swiper.params.slidesPerGroup;
                        }
                        if (JsCarousel.lastCarouselFlag === self._wrapper.data('displayid')) {
                            self.fathomTracking.updateFathomResize();
                            self.impressionTracking.updateImpressionResize();
                        }
                    }
                }, 1000);
            }
        });
    }

    __trackCarousels() {
        new JsCarouselTracking(this._, this);
    }

    _redoCounter = 0;

    initFocusable() {
        if (!this.swiper) {
            if (++this._redoCounter < 10) {
                setTimeout(() => {
                    this.initFocusable();
                }, 100);
            }
        } else {
            UpdateFocusableCarousel(this.swiper);
        }
    }

    /**
     * All event listeners in general use should be here
     * @private
     */
    __eventListeners() {
        const self = this;

        this._wrapper.on('templateDidRender', () => {
            // wait for last progress bar with an animation to complete, then force em not to reRender on resize

            this.initFocusable();

            let sel = $(this._swiperContainer)
                .find('.progress-bar')
                .not('[percentage=0]')
                .last()
                .find('.bar');
            sel.on('webkitAnimationEnd', () => {
                this.__appendHasRenderedClass();
            });
            sel.on('animationend', () => {
                this.__appendHasRenderedClass();
            });
        });

        // collapsing carousel if data fail to load aka remove carousel
        this._wrapper.on('videoDataLoadError', () => {
            self._wrapper.closest('.js-le-carousel').remove();
        });
    }

    __appendHasRenderedClass() {
        this._swiperContainer.find('.bar').each((idx, el) => {
            $(el).addClass('hasRendered');
        });
    }

    __nextBuffer() {
        if (!this.buffSize || this.options.useBuffer === false) return;
        if (this.currentParams.offset + this.buffSize >= this.total) return;
        const self = this;
        let breakpoint = this.__checkBreakpoint();

        let buffSize = breakpoint.slidesPerView * 2;
        let endpoint = this.__buildEndpoint({
            offset: self.currentParams.offset + self.buffSize,
            limit: buffSize
        });
        this.buffSize = buffSize;

        this.__pullData(endpoint, (result) => {
            // ABTEST: homepage_descriptions_web
            self.virtualSlides = this.options
                .template({
                    data: result.data,
                    editable: result.editable,
                    getLocale: getLocale,
                    hasHomePageDescriptionVariant: self.hpDescriptionsTestOn
                })
                .split('<div class="break"></div>')
                .slice(0, -1);
            self.__appendVirtualSlides(false);
            self.__revalidateLazyLoadImages();
        });
    }

    __appendVirtualSlides(force) {
        if (this.virtualSlides && this.virtualSlides.length) {
            this.swiper.virtual.appendSlide(this.virtualSlides, force);
            this.virtualSlides = null;
        }
    }

    __renderLayout(result, callback) {
        const self = this;

        this._wrapper.html(
            this.options.layout({
                title: decodeURIComponent(result.title),
                todaysDate: result.todaysDate,
                editable: result.editable,
                getLocale: getLocale,
                redDot: result.redDot
            })
        );
        this._swiperContainer = this._wrapper.find('.wrap');
        // ABTEST: homepage_descriptions_web
        this.virtualSlides = this.options
            .template({
                data: result.data,
                editable: result.editable,
                getLocale: getLocale,
                hasHomePageDescriptionVariant: self.hpDescriptionsTestOn
            })
            .split('<div class="break"></div>')
            .slice(0, -1);

        //console.log('title - ' + result.title);
        setTimeout(() => {
            try {
                this.__trackCarousels();
            } catch (e) {}
        }, 100);

        // applying shadow fader effect to carousel items
        let orientation = result.orientation;
        if (orientation === 'landscape') {
            this._swiperContainer.find('div.carousel-container').addClass('carousel-fader');
        } else if (orientation === 'square') {
            this._swiperContainer.find('div.carousel-container').addClass('square-cards');
        } else {
            this._swiperContainer.find('div.carousel-container').addClass('portrait-cards');
        }

        this._wrapper.trigger('templateDidRender');
        this._.dispatchEvent(new Event('templateDidRenderV2'));

        callback(result);
    }

    /**
     * perform pulling data & render layout
     * @param endpoint
     * @param callback This callback will be fired data successfully pulled and rendered
     */
    __pullAndRender(endpoint, callback) {
        const self = this;

        // if no endpoint, then setting up for static carousel (no buffering)
        if (endpoint === false) {
            this.__setupSettingsForPhpCarousel();
            this.__trackCarousels();
            this._wrapper.trigger('videoDataLoad')
            callback();
            return false;
        }
        this.__pullData(endpoint, (result) => {
            self.__renderLayout(result, callback);
        });
    }

    /**
     * perform reload of carousel after edit
     */
    __editAndReload(editpoint) {
        const self = this;
        self.currentParams = null;
        self.virtualSlides = null;
        self.lastIndex = 0;
        self.lastBreakPoint = null;
        self.maxSlides = 6;
        self.swiper.destroy();
        self.__init();
    }

    __pullAndRenderCarousel(endpoint, callback) {
        const self = this;

        // if no endpoint, then setting up for static carousel (no buffering)
        if (endpoint === false) {
            this.__setupSettingsForPhpCarousel();
            callback();
            return false;
        }
        this.__pullData(endpoint, (result) => {
            var myObject = {};
            myObject.result = result;
            self.__renderCarousel(myObject);
        });
    }

    __pullData(endpoint, callback) {
        const self = this;

        if (self.currentParams && self.currentParams.offset) {
            if (self.currentParams.offset >= self.total) return;
        }

        if (this.options.fetchData) {
            $.post(endpoint, this.options.params, function (resp) {})
                .then((resp) => {
                    if (isResponseSuccess(resp)) {
                        let result = resp.result;
                        // save xhr response to options for arrow tracking
                        self.options.xhrResult = result;
                        self.lastIndex += result.data.length;

                        if (result.data.length > 0) {
                            callback(result);
                        }
                        self._wrapper.trigger('videoDataLoad', result);
                    } else {
                        self._wrapper.trigger('videoDataLoadError');
                    }
                })
                .fail(() => {
                    self._wrapper.trigger('videoDataLoadError');
                });
        } else {
            $.getJSON(endpoint, function (resp) {
                if (isResponseSuccess(resp)) {
                    let result = resp.result;
                    // save xhr response to options for arrow tracking
                    self.options.xhrResult = result;
                    self.lastIndex += result.data.length;

                    if (result.data.length > 0) {
                        callback(result);
                    }
                    self._wrapper.trigger('videoDataLoad', result);
                } else {
                    Tracking.removeNumCarousels(1);
                    CarouselTracking.removeNumCarousels(1);
                    self._wrapper.trigger('videoDataLoadError');
                }
            }).fail(() => {
                self._wrapper.trigger('videoDataLoadError');
            });
        }
    }

    /**
     * Applying params values into the endpoint
     *
     * @param merge These values that will be merged with default params
     */
    __buildEndpoint(merge = {}) {
        if (
            typeof this.options.endPoint === 'undefined' ||
            this.options.endPoint === null ||
            this.options.endPoint.length <= 0
        ) {
            return false;
        }

        let breakpoint = this.__checkBreakpoint();
        this.buffSize = breakpoint.slidesPerView * 5;

        let defaultParams = {
            offset: 0,
            limit: this.buffSize,
            excludeShow: 0,
            season: 1
        };

        let params = $.extend(defaultParams, this.currentParams, merge);

        if (this.currentParams === undefined) {
            params = $.extend(defaultParams, this.options.params, merge);
        }

        // carryover current params
        this.currentParams = params;

        let endpoint = this.options.endPoint;
        for (let property in params) {
            if (params.hasOwnProperty(property)) {
                endpoint = endpoint.replace('{' + property + '}', params[property]);
            }
        }
        return endpoint;
    }

    /**
     * Renders carousel when data is available.
     *  @param data
     *  @private
     */
    __renderCarousel(data) {
        const self = this;
        this.options.useBuffer = false;

        let result = data.result;

        this._wrapper.html(
            this.options.layout({
                title: result.title,
                todaysDate: result.todaysDate,
                editable: result.editable,
                getLocale: getLocale,
                redDot: result.redDot
            })
        );

        this._swiperContainer = this._wrapper.find('.wrap');

        // ABTEST: homepage_descriptions_web
        this.virtualSlides = this.options
            .template({
                data: result.data,
                editable: result.editable,
                getLocale: getLocale,
                hasHomePageDescriptionVariant: self.hpDescriptionsTestOn
            })
            .split('<div class="break"></div>')
            .slice(0, -1);

        if (result.editable) {
            this._wrapper.find('.carousel-container').addClass('carousel-fader');
        }

        // applying shadow fader effect to carousel items
        let orientation = result.orientation;
        if (orientation === 'landscape') {
            this._swiperContainer.find('div.carousel-container').addClass('carousel-fader');
        } else if (orientation === 'portrait') {
            this._swiperContainer.find('div.carousel-container').addClass('portrait-cards');
        } else if (orientation === 'square') {
            this._swiperContainer.find('div.carousel-container').addClass('square-cards');
        }

        this._wrapper.trigger('templateDidRender');

        this.__initSwiper();
        this.total = (result && result.total) || 0;
        this.__trackingArrow();
        this.__trackCarousels();

        // ABTEST: homepage_descriptions_web
        this.__initAnimation();

        this.__initEdit();

        this._wrapper.find('.carousel-container').css('opacity', '1');
    }

    // START ABTEST: homepage_descriptions_web
    __slidesAnimations(slides, cssProps) {
        if (slides.length > 0 && cssProps) {
            slides.each(function () {
                $(this).css(cssProps);
            });
        }
    }

    __isTabletPortraitMore() {
        const isSafari = /^(?!.*chrome).*safari/i.test(navigator.userAgent);
        let b = new Breakpoints();
        let windowWidth = isSafari ? $(window).width() : $(window).outerWidth();
        return windowWidth >= b.getMin('tabletLandscape');
    }

    __initAnimation(callback) {
        let selfObject = this;
        let containerId = this._wrapper.parents('.js-le-carousel').attr('id');

        // checks for the "description" variant being on before enabling the animation
        if (!selfObject.hpDescriptionsTestOn) {
            return false;
        }

        let slides = this._wrapper.find('.carousel-container .swiper-slide-visible');
        slides.each(function (index, slide) {
            // Ignoring "on-now" section slides
            if ($(slide).parents('section#on-now').length > 0) {
                return false;
            }

            // Removes previously created events and appends hover event listener
            $(this)
                .unbind()
                .hover(
                    function () {
                        const self = $(this);
                        let videoBox = self.parents('.video-carousel-box');

                        if (
                            selfObject._wrapper.attr('id') !== 'brands-carousel' &&
                            containerId !== 'on-now' &&
                            containerId !== 'whats-new' &&
                            selfObject.__isTabletPortraitMore() &&
                            !videoBox.hasClass('editOn') &&
                            selfObject.hpDescriptionsTestOn
                        ) {
                            if (
                                selfObject._wrapper.attr('id') !== 'brands-carousel' &&
                                containerId !== 'on-now' &&
                                containerId !== 'whats-new' &&
                                selfObject.__isTabletPortraitMore() &&
                                !videoBox.hasClass('editOn') &&
                                selfObject.hpDescriptionsTestOn
                            ) {
                                // Lazy load poster image
                                let poster = self.find('.poster');
                                selfObject.__preloadImage(poster.attr('data-src'), () => {
                                    poster.attr('src', poster.attr('data-src'));
                                });

                                setTimeout(function () {
                                    let slide = self;
                                    if (slide.is(':hover') === true) {
                                        const thumbWrapper = self.find('.thumb-wrapper');
                                        const hoverWrapper = thumbWrapper.find(
                                            '.homepage-description-wrapper'
                                        );
                                        const isPortraitCard = self.parents('.portrait-cards');
                                        const containerID = self
                                            .parents('.js-le-carousel')
                                            .attr('id');
                                        const dataFathom = thumbWrapper
                                            .parent()
                                            .attr('data-fathom');
                                        const isHybridCarousel = dataFathom.includes('hybrid');
                                        const isMovie = dataFathom.includes('movie');
                                        let prevCssStr = {};
                                        let nextCssStr = {};

                                        hoverWrapper.css({ visibility: 'visible' });
                                        let contentID = slide.find('a').attr('vilynx-id');

                                        if (
                                            slide.prev().hasClass('swiper-slide-visible') ===
                                                false ||
                                            slide.is(':first-child')
                                        ) {
                                            thumbWrapper.css({ 'transform-origin': 'center left' });
                                            nextCssStr =
                                                isPortraitCard.length > 0
                                                    ? { transform: 'translateX(170%)' }
                                                    : { transform: 'translateX(100%)' };
                                        } else if (
                                            slide.next().hasClass('swiper-slide-visible') ===
                                                false ||
                                            slide.is(':last-child')
                                        ) {
                                            thumbWrapper.css({
                                                'transform-origin': 'center right'
                                            });
                                            prevCssStr =
                                                isPortraitCard.length > 0
                                                    ? { transform: 'translateX(-170%)' }
                                                    : { transform: 'translateX(-100%)' };
                                        } else {
                                            thumbWrapper.css({ 'transform-origin': 'center' });
                                            prevCssStr =
                                                isPortraitCard.length > 0
                                                    ? { transform: 'translateX(-85%)' }
                                                    : { transform: 'translateX(-50%)' };
                                            nextCssStr =
                                                isPortraitCard.length > 0
                                                    ? { transform: 'translateX(85%)' }
                                                    : { transform: 'translateX(50%)' };
                                        }

                                        if (isPortraitCard.length > 0) {
                                            thumbWrapper.css({
                                                transform: 'scaleX(2.7)',
                                                transition: 'transform 0.2s'
                                            });
                                            let poster = thumbWrapper.find('.poster');
                                            poster.attr('src', poster.attr('data-src'));
                                            let showId = !isHybridCarousel
                                                ? thumbWrapper
                                                      .find('.homepage-description-wrapper')
                                                      .attr('show-id')
                                                : thumbWrapper.parent().attr('id');
                                            let endPoint = `/carousels/homepage/dynamicPlay/showId/${showId}/`;
                                            containerID === 'trending-movies'
                                                ? selfObject.__appendVideo(contentID, thumbWrapper)
                                                : selfObject.__getDynamicPlay(
                                                      endPoint,
                                                      thumbWrapper
                                                  );
                                        } else {
                                            thumbWrapper.css({
                                                transform: 'scaleX(2) scaleY(2)',
                                                transition: 'transform 0.2s'
                                            });
                                            selfObject.__appendVideo(contentID, thumbWrapper);
                                        }

                                        selfObject.__slidesAnimations(slide.prevAll(), prevCssStr);
                                        selfObject.__slidesAnimations(slide.nextAll(), nextCssStr);

                                        thumbWrapper.attr('description-animation', true);
                                    }
                                }, 750);
                            } else {
                                let thumbWrapper = $(this).find('.thumb-wrapper');
                                thumbWrapper.parents('.swiper-slide').css({ 'z-index': 1000 });
                                thumbWrapper.css({
                                    transform: 'scaleX(1.125) scaleY(1.125)',
                                    transition: 'transform 0.3s'
                                });
                            }
                        }
                    },
                    function () {
                        let videoBox = $(this).parents('.video-carousel-box');
                        let slide = $(this);
                        let thumbWrapper = $(this).find('.thumb-wrapper');

                        if (!videoBox.hasClass('editOn')) {
                            thumbWrapper.parents('.swiper-slide').css({ 'z-index': '' });
                            thumbWrapper.css({
                                transform: 'scaleX(1) scaleY(1)',
                                transition: 'transform 0.25s'
                            });
                            thumbWrapper.find('.video-wrapper').remove();
                            thumbWrapper
                                .find('.homepage-description-wrapper')
                                .css({ visibility: 'hidden' });

                            let cssObj = {
                                transition: 'transform 0.25s',
                                'transition-delay': '0s',
                                transform: 'translateX(0%)'
                            };
                            selfObject.__slidesAnimations(slide.prevAll(), cssObj);
                            selfObject.__slidesAnimations(slide.nextAll(), cssObj);

                            if (
                                selfObject.hpDescriptionsTestOn &&
                                typeof thumbWrapper.attr('description-animation') !== 'undefined'
                            ) {
                                thumbWrapper.removeAttr('description-animation');
                            }
                        } else {
                            thumbWrapper.parents('.swiper-slide').css({ 'z-index': 'unset' });
                            thumbWrapper.css({
                                transform: 'scaleX(1) scaleY(1)',
                                transition: 'transform 0.3s'
                            });
                        }
                    }
                );
        });

        // Loads callback if defined
        if (typeof callback !== 'undefined') {
            callback();
        }
    }

    __getDynamicPlay(endpoint, wrapper) {
        const self = this;
        $.getJSON(endpoint, function (resp) {
            if (resp.content_id) {
                self.__appendVideo(resp.content_id, wrapper);
            }
        }).fail(() => {});
    }

    __appendVideo(cid, wrapper) {
        setTimeout(function () {
            if (typeof cid !== 'undefined') {
                let $videoWrapper = $('<div>', { class: 'video-wrapper' });
                let $previewVideo = $('<video>', {
                    name: 'media',
                    autoplay: ''
                }).prop('muted', true);
                let previewVideo = $previewVideo.get(0);
                let $source = $('<source>', { type: 'video/mp4' });
                let s = $source.get(0);
                s.src = 'https://splice.amlg.io/api/v2/video/' + cid + '/preview/high69.mp4';
                s.onerror = function () {
                    $videoWrapper.remove();
                };
                previewVideo.addEventListener('loadeddata', function () {
                    $videoWrapper.addClass('on-playing');
                });
                $videoWrapper.append($previewVideo.append($source));
                $videoWrapper.insertAfter(wrapper.find('.homepage-description-wrapper'));
            }
        }, 250);
    }

    __preloadImage(url, imageLoadedCallback) {
        var img = new Image();
        img.src = url;
        img.onload = imageLoadedCallback;
    }

    // END ABTEST: homepage_descriptions_web

    /**
     * Getting the current breakpoint
     *
     * @returns currentBreakpoint
     * @private
     */
    __checkBreakpoint() {
        let windowWidth = window.innerWidth || $(window).width();
        let breakpoints = this.options.responsive;
        let currentBreakpoint;

        for (let breakpoint in breakpoints) {
            if (windowWidth < breakpoint) {
                currentBreakpoint = breakpoints[breakpoint];
                break;
            }
        }

        return currentBreakpoint;
    }

    __revalidateLazyLoadImages(timeout) {
        return setTimeout(() => {
            if (CBS.Registry.lazyImage) {
                CBS.Registry.lazyImage.load(this.swiper.visibleSlides.find('img'));
                let nextIndex =
                    this.swiper.visibleSlidesIndexes[this.swiper.visibleSlidesIndexes.length - 1] +
                    1;
                if (this.swiper.slides[nextIndex]) {
                    CBS.Registry.lazyImage.load(this.swiper.slides[nextIndex].querySelector('img'));
                }
            }
        }, timeout || 5);
    }
    getWrapper() {
        return this._wrapper;
    }
}

/**
 * This is the proxy construct the JsCarousel
 */
$.fn.JsCarousel = function () {
    let _ = this;
    let opt = arguments[0];

    for (let i = 0; i < _.length; i++) {
        new JsCarousel(_[i], opt);
    }
};

/*
 * HELPER FUNCTIONS
 */
function isResponseSuccess(resp) {
    return (
        typeof resp == 'object' &&
        resp.success &&
        typeof resp.result != 'undefined' &&
        typeof resp.result.data != 'undefined' &&
        resp.result.data.length > 0
    );
}

function toTitleCase(str) {
    return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1);
    });
}
